import { render, staticRenderFns } from "./cq-credits.vue?vue&type=template&id=47897829&scoped=true&"
import script from "./cq-credits.vue?vue&type=script&lang=js&"
export * from "./cq-credits.vue?vue&type=script&lang=js&"
import style0 from "./cq-credits.vue?vue&type=style&index=0&id=47897829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47897829",
  null
  
)

export default component.exports